// extracted by mini-css-extract-plugin
export var errorIcon = "_m0-1";
export var nameLogo = "_m0-0";